import { render, staticRenderFns } from "./FolImportacaoRecibo.vue?vue&type=template&id=73212b29&"
import script from "./FolImportacaoRecibo.vue?vue&type=script&lang=js&"
export * from "./FolImportacaoRecibo.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./FolImportacaoRecibo.vue?vue&type=style&index=1&id=73212b29&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports